var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.125 3.67511C29.375 3.55011 27.55 3.95011 25.925 4.90011C24.8811 5.4978 23.9655 6.29565 23.2306 7.24793C22.4957 8.20021 21.9561 9.28818 21.6425 10.4495C21.329 11.6107 21.2477 12.8225 21.4035 14.0152C21.5592 15.208 21.9488 16.3583 22.55 17.4001L40.9 49.1501C43.425 53.5501 49.025 55.0001 53.425 52.5001C57.8 50.0001 59.25 44.3751 56.75 40.0001L38.45 8.25011C37.6942 6.94846 36.6317 5.85123 35.3551 5.05387C34.0784 4.25652 32.6263 3.78321 31.125 3.67511ZM17.55 16.9001L4.25 40.0001C3.43958 41.3892 3.00851 42.9669 3 44.5751C3 45.78 3.23732 46.9731 3.69841 48.0862C4.15949 49.1994 4.83532 50.2108 5.68729 51.0628C6.53927 51.9148 7.55072 52.5906 8.66388 53.0517C9.77704 53.5128 10.9701 53.7501 12.175 53.7501C13.7832 53.7452 15.362 53.3176 16.7529 52.5103C18.1438 51.7029 19.2981 50.5442 20.1 49.1501V49.1751L28 35.4751C24.625 29.7251 21.175 24.0001 18.075 18.0751C17.875 17.7001 17.7 17.3001 17.575 16.9001H17.55Z",
    fill: "#80FF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpc);
export default __webpack_public_path__ + "homepage/static/media/PPC.4bd276346c5d0d83d458b17a90bc87e6.svg";
export { ForwardRef as ReactComponent };